import { Flex } from '@/components/base';
import Tooltip from '@/components/Tooltip/TooltipV2';
import chartUtils from '@/features/(charts)/chart-renderer/lib/chart-utils';
import TicketLabel from '@/features/Commons/Ticket/TicketLabel';
import useColor from '@/hooks/domain/useColor';
import { getAlphaColor } from '@/styles/colors/color.utils';

type Props = {
  term: ChartTermDef;
  compareTerm?: ChartCompareTermDef;
  static?: boolean;
};

const formatComparisonRange = (dateRange: string) =>
  dateRange.replace(/, \d{4}/g, '').replace(' - ', '–');

const DateRangeDisplay = (props: Props) => {
  const color = useColor();

  const dateString = chartUtils.getReadableDateRangeByTerm(props.term);

  const compareDateString = chartUtils.getReadableDateRangeByCompareTerm(
    props.term,
    props.compareTerm,
  );

  if (props.static) {
    return (
      <Flex g={8}>
        <Tooltip tooltipNode={dateString}>
          <TicketLabel>Current : {dateString}</TicketLabel>
        </Tooltip>
        {compareDateString && (
          <Tooltip tooltipNode={compareDateString}>
            <TicketLabel
              style={{
                color: getAlphaColor(color.primary100, 0.6),
              }}
            >
              Compare : {compareDateString}
            </TicketLabel>
          </Tooltip>
        )}
      </Flex>
    );
  }
  return (
    <Flex g={8} className="flex-wrap">
      <Tooltip tooltipNode={dateString}>
        <TicketLabel>{chartUtils.getTermString(props.term)}</TicketLabel>
      </Tooltip>
      {compareDateString && (
        <TicketLabel>
          <span
            className="inline-flex items-center gap-1 whitespace-nowrap tabular-nums"
            aria-label={`${formatComparisonRange(dateString)} compared with ${formatComparisonRange(compareDateString)}`}
          >
            <span className="font-semibold">
              {formatComparisonRange(compareDateString)}
            </span>
            <span
              aria-hidden="true"
              className="rounded bg-gray-200 px-1.5 py-0.5 text-[10px] font-bold leading-none tracking-wide text-gray-600"
            >
              VS
            </span>
            <span className="font-semibold">
              {formatComparisonRange(dateString)}
            </span>
          </span>
        </TicketLabel>
      )}
    </Flex>
  );
};

export default DateRangeDisplay;
